var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlagSlovakia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3223_17646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 10.5322 23.736 9.12605 23.2536 7.82611H0.746391C0.264047 9.12605 0 10.5322 0 12C0 18.6274 5.37262 24 12 24Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 24C17.1593 24 21.5578 20.7435 23.2533 16.1739H0.746094C2.44161 20.7435 6.84012 24 11.9997 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10156 6.78262V12.7688C3.10156 16.174 7.55005 17.2174 7.55005 17.2174C7.55005 17.2174 11.9985 16.174 11.9985 12.7688V6.78262H3.10156Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14844 6.78262V12.7688C4.14844 13.1686 4.23722 13.5461 4.41309 13.9001H10.6937C10.8696 13.5462 10.9584 13.1686 10.9584 12.7688V6.78262H4.14844Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63873 10.9565H8.07358V9.91303H9.11706V8.86955H8.07358V7.82611H7.03009V8.86955H5.98666V9.91303H7.03009V10.9565H5.46484V12H7.03009V13.0435H8.07358V12H9.63873V10.9565Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83342 15.3567C6.50584 15.7793 7.19669 16.0246 7.55036 16.1338C7.90403 16.0247 8.59488 15.7793 9.2673 15.3567C9.94539 14.9305 10.4207 14.4431 10.6907 13.9001C10.393 13.6895 10.0297 13.5652 9.63733 13.5652C9.49445 13.5652 9.35566 13.5822 9.2222 13.6132C8.93941 12.9707 8.29745 12.5218 7.55041 12.5218C6.80336 12.5218 6.16136 12.9707 5.87861 13.6132C5.74516 13.5822 5.60631 13.5652 5.46348 13.5652C5.07109 13.5652 4.70786 13.6895 4.41016 13.9001C4.67992 14.4431 5.15528 14.9305 5.83342 15.3567Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3223_17646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagSlovakia);
export default __webpack_public_path__ + "static/media/icon_flag_slovakia.855437457e0ed214d7a26891cae60a14.svg";
export { ForwardRef as ReactComponent };